/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Row_Permit_ActionInputs */



/**
* | output |
* | --- |
* | "Permit in organization" |
*
* @param {Integrations_Row_Permit_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_row_permit_action = /** @type {((inputs?: Integrations_Row_Permit_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Row_Permit_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In der Organisation erlauben")
	return /** @type {LocalizedString} */ ("Permit in organization")
});